import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    flexDir: 'row',
    justify: 'space-between',
  },
  headerHeading: {
    alignItems: 'center',
    display: 'flex',
    flexDir: 'row',
    fontSize: 'md',
  },
  headerIconButton: {
    color: 'white',
    p: '1',
    size: 'xs',
    _hover: {
      opacity: '.8',
    },
  },
  headerSkeletonText: {
    sx: {
      '.state-prior': { color: 'white' },
    },
  },
  headerVsBox: {
    color: 'white',
  },
  bodyStack: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: ['2', null, null, '4'],
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    h: '1.25em',
    ml: '1',
    w: 'auto',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'none',
  },
  toMarketButton: {
    borderColor: 'beta.500',
    color: 'white',
    _active: {
      bg: 'beta.500',
      color: 'alpha.600',
    },
    _hover: {
      color: 'beta.500',
    },
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    border: '0',
    borderRadius: 'base',
    boxShadow:
      '0 3px 5px rgba(0, 0, 0, .2), 0 1px rgba(255, 255, 255, .15) inset',
    overflow: 'hidden',
  },
  accordionButton: {
    bgGradient: 'linear(to-b, zeta.400, zeta.600)',
    color: 'alpha.600',
    fontSize: 'xs',
    fontWeight: 'bold',
    p: '2',
    pos: 'relative',
    textAlign: 'left',
    boxShadow:
      '0px -1px 0px 0px rgba(255, 255, 255, 0.20) inset, 0px -2px 0px 0px rgba(0, 0, 0, 0.15) inset',
    _expanded: {
      _after: { opacity: '1' },
    },
    _hover: {
      bgGradient: 'linear(to-b, zeta.500, zeta.600)',
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'alpha.600',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'alpha.600',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    p: '0',
  },
  cancelButton: {
    variant: 'solid',
    px: '3',
  },
  clearButton: {
    variant: 'solid',
    ml: '3',
    px: '3',
  },
  countdown: {
    sx: {
      textTransform: 'uppercase',
      '&&&.state-prior': {
        p: 0,
        lineHeight: 'initial',
      },
    },
  },
  sgmLogoV2: {
    color: 'white',
    w: '8',
    h: 'auto',
  },
  wrapperScrollSgm: { w: '100%', maxW: '100%', gap: '2', mt: '2' },
  scrollButtonGroupV2: {
    flex: 1,
    position: 'relative',
    minH: '34px',
    bg: 'none',
    boxShadow: 'none',
    w: '660px',
  },
  accordionItemActive: {
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  },
  toMarketButtonV2: {
    color: 'white',
    fontSize: 'xs',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontWeight: 'bold',
    cursor: 'pointer',
    border: 'none',

    _hover: {
      color: 'beta.500',
    },

    sx: {
      '&&': {
        px: 2,
        ml: 0,
      },

      '&[data-active]': {
        color: 'beta.500',
        bg: 'none',
        border: 'none',
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },

    _last: { mr: 2 },
  },
  sgmBtn: {
    bgGradient: 'linear(to-b, delta.400, delta.600)',
    borderColor: '#000',
    borderStyle: 'solid',
    borderWidth: '2px',
    boxShadow:
      '0px 4px 10px 0px rgba(0, 0, 0, 0.25), 0px 1px 0px 0px rgba(255, 255, 255, 0.50) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.30) inset',
    color: 'alpha.500',
    px: '2',
    sx: {
      svg: {
        color: 'gamma.700',
        fill: 'gamma.700',
        textShadow: '0px 1px 2px rgba(255, 255, 255, 0.40)',
      },
    },
  },
  sgmBtnActive: {
    sx: {
      svg: {
        color: 'delta.300',
        fill: 'delta.300',
        textShadow: '0px 1px 3px rgba(0, 0, 0, 0.45)',
      },

      '&&': {
        border: 'none',
        px: '2.5',
        bg: 'gamma.800',
        boxShadow:
          '0px -1px 0px 0px rgba(0, 0, 0, 0.55) inset, 0px 2px 0px 1px rgba(0, 0, 0, 0.55) inset;',
        borderColor: 'transparent',
      },
    },

    _after: { display: 'none' },
  },
};
